module.exports = __webpack_public_path__ + "static/media/stamp_17.10224512.png";